export const PAGES = {
  DASHBOARD: '/dashboard/overview',
  SNAPSHOTS: '/dashboard/snapshots',
  FUNNEL: '/dashboard/funnel',
  REPORTS: '/dashboard/reports',
  SEGMENTS: '/dashboard/segments',
} as const;
